module.exports = __webpack_public_path__ + "media/images/subhead-background-b44332846ffc3c4a30bc35de0aac1810.png";